// import { isMobile } from "./functions.js";
// import { formsModules } from "./forms/forms.js";
import f from './query';
import {ut} from './files/functions';

import {Modal} from './files/modal/Modal';
import {Valid} from "./files/valid/Valid";

const toggleWishlist = (icon, id) => {
  if (!isFinite(id)) return;

  f.Get({data: 'mode=toggleWishlist&id=' + id}).then(d => {
    const headerIcon = document.querySelector('#wishLink .wishIcon');

    d = d || [];

    headerIcon.innerHTML = d.length || '';
    headerIcon.style.display = d.length ? 'initial' : 'none';

    if (d.includes(id)) icon.classList.add('selected');
    else icon.classList.remove('selected');
  });
}

function documentActions(e) {
  const target = e.target;
  const checkTarget = className => target.classList.contains(className) || target.closest('.' + className);

  // Header catalog menu
  if (checkTarget('btnCatalog')) {
    if (document.body.clientWidth <= 767) { //mobile
      document.querySelector('[data-role="bx-menu-button-mobile"]').click();
      return false;
    }

    const menuNode = document.getElementById('catalogMenuMultilevel'),
          iconS = 'icon-widget',
          iconA = 'icon-close';

    menuNode.classList.toggle('active');

    if (menuNode.classList.contains('active')) {
      target.parentNode.querySelector('span').setAttribute('class', iconA);
    } else {
      target.parentNode.querySelector('span').setAttribute('class', iconS);
    }

    return false;
  }
  // Toggle favorite products
  if (checkTarget('toggleWishlist')) {
    const iconNode = target.closest('.toggleWishlist') || target;
    toggleWishlist(iconNode, iconNode.dataset.id);
  }
  // Callback modal
  if (checkTarget('btnCallback')) {
    const m = window.vF.Modal({showDefaultButton: false}),
          template = vF.gTNode('#tmpCallback'),
          templateOk = vF.gT('#tmpOk'),
          templateErr = vF.gT('#tmpErr');

    const sendFunc = (data, finish, e) => {
      window.vF.setLoading(e.target);

      data.set('mode', 'sendMail');

      window.vF.Post({data}).then(data => {
        if (data.status) m.show(' ', templateOk);
        else m.show(' ', templateErr);

        f.removeLoading(e.target);
        finish();
      })
    };

    new Valid({
      sendFunc,
      form: template.querySelector('form'),
      submit: template.querySelector('.confirmYes'),
    });

    m.show(' ', template);
    e.preventDefault();
  }

}

function replaceLoader() {
  let loader = document.createElement('div');

  loader.classList.add('loader-st1', 'center-screen');
  loader.innerHTML = `<div class="lds-dots">${'<div></div>'.repeat(12)}</div>`;

  BX.showWait = function() {
    document.body.append(loader);
  };
  BX.closeWait = function() {
    loader.remove();
  };
}

export const mainInit = () => {
  replaceLoader();
  document.addEventListener("click", documentActions);

  window.vF = {...f, ...ut, Modal};
}
